import {Spellcasting} from "@/characters/model/Character.ts";
import {useModal} from "@/modal/ModalHooks.ts";
import DetailSection from "@/components/details/DetailSection.tsx";

export default function SpellcastingView({spellcasting}: { spellcasting: Spellcasting }) {

    const {showSpell} = useModal();
    const spellCount = spellcasting.spellGroups.reduce((count, group) => count + group.spells.length, 0);
    const headerDetails = <div className="flex flex-wrap justify-end gap-x-3 text-[0.7rem] text-muted-foreground">
        {spellcasting.skill != undefined && <span>Angriff <strong className="text-foreground">+{spellcasting.skill}</strong></span>}
        {spellcasting.saveDc != undefined && <span>SG <strong className="text-foreground">{spellcasting.saveDc}</strong></span>}
        {spellcasting.attribute && <span>Attribut <strong className="uppercase text-foreground">{spellcasting.attribute}</strong></span>}
    </div>;

    return <DetailSection title="Zauberwirken"
                          count={spellCount}
                          info={spellcasting.description}
                          headerDetails={headerDetails}>
        <div className="space-y-0.5 text-[0.8125rem] leading-snug">
            {spellcasting.spellGroups.map(group =>
                <div key={spellcasting.type === "Klasse" ? group.level : group.frequency}>
                    {spellcasting.type === "Klasse" &&
                        <span className="font-bold" style={{fontVariant: "small-caps"}}>
                            {group.level == 0 ? "Zaubertricks (beliebig): " : `${group.level}. Grad (${group.slots} Plätze):`}
                        </span>
                    }
                    {spellcasting.type === "Angeboren" &&
                        <span className="font-bold" style={{fontVariant: "small-caps"}}>
                            {group.frequency}
                        </span>
                    }
                    {group.spells.map(spell =>
                        <span className="inline-flex" key={spell.id}>
                            <button type="button"
                                    className="ms-1 cursor-pointer px-0.5 text-warning underline decoration-warning/50 underline-offset-2 transition-colors hover:text-amber-300"
                                    onClick={() => showSpell(spell.id)}>{spell.name}</button>
                        </span>)}
                </div>
            )}
        </div>
    </DetailSection>;
}
